var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcQuickMsg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "16px",
    viewBox: "0 0 21 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icQuickMsg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1---USER-STARTS-CALL",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icQuickMsg",
    transform: "translate(0.000000, 1.000000)",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    strokeWidth: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66666667,7.33333333 C4.95574644,9.03758338 6.02587867,9.87558849 7.75473086,10.706988 L7.75473086,13.7841267 C7.75473086,13.8631708 7.80187363,13.9365513 7.87757485,13.9741445 C7.91218599,13.9914636 7.9503776,14 7.98831346,14 C8.03306925,14 8.07791028,13.9879341 8.11669864,13.9642126 L11.8563219,11.6766942 C12.0076391,11.6839995 12.1492379,11.6913868 12.2934794,11.6913868 C16.6871339,11.6913868 20,9.17830948 20,5.84589858 C20,2.51307728 16.6871339,0 12.2934794,0 C10.09678,0 8.17023508,0.6282488 6.79277977,1.6731413 L10.1359093,1.6731413 L7,7.33333333 L4.66666667,7.33333333 Z",
    id: "Stroke-3",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,3.33333333 L8,3.33333333",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,4.66666667 L6,4.66666667",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,6 L5.33333333,6",
    id: "Stroke-9"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    strokeWidth: 0.6,
    fill: "#000",
    cx: 10.6666667,
    cy: 6,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    strokeWidth: 0.6,
    fill: "#000",
    cx: 13.3333333,
    cy: 6,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    strokeWidth: 0.6,
    fill: "#000",
    cx: 16,
    cy: 6,
    r: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQuickMsg);
export default __webpack_public_path__ + "static/media/icQuickMsg.16ffe3b31b972c328474111ecfe1f25e.svg";
export { ForwardRef as ReactComponent };